import * as types from "./auth.actionTypes";
import { setItem } from "../../utils/localStorage";
import apiClient, {
  setAccessToken,
  clearAuthStorage,
} from "../../services/apiService";

export const loginUser = (creds) => (dispatch) => {
  dispatch({ type: types.LOGIN_USER_REQUEST });
  return apiClient
    .post(`/auth/login`, creds)
    .then((res) => {
      if (res?.data?.token) {
        const username = res.data.user.username.split(" ")[0];
        setAccessToken(res.data.token);
        setItem("username", username);
        dispatch({ type: types.LOGIN_USER_SUCCESS, payload: res.data.token });
        return true;
      } else {
        clearAuthStorage();
        dispatch({ type: types.LOGIN_USER_FAILURE });
        return false;
      }
    })
    .catch((err) => {
      clearAuthStorage();
      dispatch({ type: types.LOGIN_USER_FAILURE });
    });
};

export const logoutUserApi = () => (dispatch) => {
  // Best-effort: clear the httpOnly refresh cookie on the server, then wipe
  // local auth state regardless of the network result.
  apiClient.post(`/auth/logout`).catch(() => {});
  clearAuthStorage();
  dispatch({ type: types.LOGOUT_USER });
};

// Silent re-authentication used on app load: if a valid refresh cookie exists,
// this mints a fresh access token without any user interaction.
export const restoreSession = () => async (dispatch) => {
  try {
    const res = await apiClient.post(`/auth/refresh`);
    if (res?.data?.token) {
      setAccessToken(res.data.token);
      if (res.data?.user?.username) {
        setItem("username", res.data.user.username.split(" ")[0]);
      }
      dispatch({ type: types.RESTORE_SESSION_SUCCESS, payload: res.data.token });
      return true;
    }
    return false;
  } catch (err) {
    clearAuthStorage();
    dispatch({ type: types.LOGOUT_USER });
    return false;
  }
};

export const signUpUser = (userData) => async (dispatch) => {
  dispatch({ type: types.SIGN_UP_REQUEST });

  try {
    const response = await apiClient.post(`/auth/signup`, userData);

    dispatch({
      type: types.SIGN_UP_SUCCESS,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: types.SIGN_UP_FAILURE,
      payload: error.response?.data?.message || "Sign-up failed",
    });

    return { success: false, message: error.response?.data?.message || error.message };
  }
};
